import { computed } from 'vue';
import { countriesShopify } from '@shopexperts/shared';

export function useCountries() {
    const countryOptions = computed(() => 
        countriesShopify.map(c => ({
            value: c.iso2,
            label: c.name
        }))
    );

    const countryByIso2 = computed(() => 
        Object.fromEntries(countriesShopify.map(c => [c.iso2, c]))
    );

    return { 
        countryOptions,
        countryByIso2
    };
}

